import { Stack, Typography } from '@mui/material'
import type { SurveyElement } from '../MidYearSummary'
import { linkifyText } from '../../../../../../../utils/linkifyText'
import { parseSurveyText } from '../../../../../../customComponents/survey/questions/components/parseSurveyText'

interface Props {
  element: SurveyElement
  answers: Record<string, any>
}
export const SummaryText = ({ element, answers }: Props): JSX.Element => {
  const answer = answers[element.name]

  return (
    <Stack gap={1}>
      <Typography variant='body1'>{parseSurveyText(element.title)}</Typography>
      {element.description != null && element.description !== '' && (
        <Typography
          variant='body1'
          fontWeight='bold'
          sx={{ color: 'var(--BaseTones-primitive-nuetral-500, rgba(89, 85, 91, 1))' }}
        >
          {parseSurveyText(element.description)}
        </Typography>
      )}
      {answer != null && answer !== ''
        ? <Typography variant='body1' fontWeight='bold'>{linkifyText(answer)}</Typography>
        : <Typography variant='body1' color='text.disabled'>No response provided</Typography>
      }
    </Stack>
  )
}
